<template>
  <div>
    <!-- Lightbox -->
    <vue-easy-lightbox
      :visible="isLightboxVisible"
      :imgs="lightboxImg"
      @hide="isLightboxVisible = false"
    />

    <!-- Dialog components -->
    <LoginPopup :dialog="isLoginPopun" @close-dialog="closeDialog('loginPopun')" />
    <RDVPicker
      :dialog="isBookClicked"
      :offDays="nutrition.nutrition.openningHours.map(item=> {return item.day})"
      @close-dialog="closeDialog('bookCoach')"
    />

    <v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
    <v-container fluid grid-list-md class="my-2" v-if="nutrition">
      <v-layout row wrap>
        <!-- BADGE Nutrionist -->
        <v-flex md4 order-md1>
          <div>
            <v-card outlined height="full-height" class="mx-auto">
              <v-img
                contain
                :aspect-ratio="1"
                style="cursor: pointer;"
                :alt="nutrition.name"
                @click="isLightboxVisible=true;lightboxImg=nutrition.photoUrl"
                :lazy-src="photoConvert(nutrition.photoUrl)"
                :src="photoConvert(nutrition.photoUrl)"
                height="200px"
              ></v-img>
              <v-card-title>{{ nutrition.name }}</v-card-title>
              <v-card-text>{{ nutrition.description }}</v-card-text>
              <v-list>
                <v-list-item v-if="nutrition.phone">
                  <v-list-item-icon>
                    <v-icon color="secondary">mdi-cash</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <span class="body-2">{{nutrition.nutrition.sessionPrice}}dt /séance</span>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn rounded color="primary" depressed @click="onBookCoach">Prendre RDV</v-btn>
                  </v-list-item-action>
                </v-list-item>
                <v-list-item v-if="nutrition.phone">
                  <v-list-item-icon>
                    <v-icon color="secondary">mdi-phone</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>+216 - {{ nutrition.phone }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="nutrition.mail">
                  <v-list-item-icon>
                    <v-icon color="secondary">mdi-email</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>{{ nutrition.mail }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <SocialMedia
                  :facebook="nutrition.facebook"
                  :instagram="nutrition.instagram"
                  :website="nutrition.website"
                  :youtube="nutrition.youtube"
                />
              </v-list>
              <v-flex xs12 fill-height>
                <v-card justify-center wrap flat class="text-center pa-2">
                  Notez {{nutrition.name}}
                  <v-rating></v-rating>
                </v-card>
              </v-flex>
            </v-card>
          </div>
        </v-flex>

        <!-- CONTENT -->
        <v-flex md8 order-md2>
          <v-layout row>
            <v-flex md6>
              <!-- Schedule -->
              <v-card height="100%" class="text-center pa-2" outlined>
                <ScheduleCard :openningHours="nutrition.nutrition.openningHours" />
              </v-card>
            </v-flex>
            <v-flex md6 v-if="nutrition.city || nutrition.country || nutrition.zipCode">
              <v-card justify-center wrap height="100%" class="text-center" outlined>
                <v-row>
                  <v-col cols="4">
                    <p class="body-2">Consultation en ligne</p>
                    <v-tooltip left v-if="nutrition.nutrition.online">
                      <p
                        class="body-2"
                        style="margin-bottom: 2px;"
                      >accepte les consultations en ligne</p>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          style="margin-bottom: 4px;"
                          color="success"
                          left
                          v-on="on"
                        >mdi-checkbox-marked-circle-outline</v-icon>
                      </template>
                    </v-tooltip>
                    <v-tooltip left v-else>
                      <p
                        class="body-2"
                        style="margin-bottom: 2px;"
                      >n'accepte pas les consultations en ligne</p>
                      <template v-slot:activator="{ on }">
                        <v-icon style="margin-bottom: 4px;" left v-on="on">mdi-close-circle-outline</v-icon>
                      </template>
                    </v-tooltip>
                  </v-col>
                  <v-col cols="4">
                    <p style="margin-bottom: 4px;" class="body-2">CNAM</p>
                    <div class="align-content-center">
                      <v-tooltip bottom v-if="nutrition.nutrition.cnam">
                        <p
                          class="body-2"
                          style="margin-bottom: 2px;"
                        >ce nutritionniste est conventionné avec la CNAM</p>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            style="margin-bottom: 4px;"
                            color="success"
                            left
                            v-on="on"
                          >mdi-checkbox-marked-circle-outline</v-icon>
                        </template>
                      </v-tooltip>
                      <v-tooltip left v-else>
                        <p
                          class="body-2"
                          style="margin-bottom: 2px;"
                        >n'est pas conventionné avec la CNAM</p>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            style="margin-bottom: 4px;"
                            left
                            v-on="on"
                          >mdi-close-circle-outline</v-icon>
                        </template>
                      </v-tooltip>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <p style="margin-bottom: 4px;" class="body-2">Année d'éxperience</p>
                    <p
                      v-if="nutrition.nutrition.ExpYears"
                      class="body-2"
                      style="margin-bottom: 2px;"
                    >{{nutrition.nutrition.ExpYears}}ans</p>
                    <p
                      v-else
                      class="body-2 text--secondary"
                      style="margin-bottom: 2px;"
                    >n'est pas mentionnée</p>
                  </v-col>
                </v-row>
              </v-card>
            </v-flex>
            <v-flex md12>
              <v-card justify-center wrap height="100%" class="text-center pa-2" outlined>
                <p>{{nutrition.adress}},</p>
                <p class="font-weight-light">
                  <span v-if="nutrition.country">{{nutrition.country+","}}</span>
                  <span v-if="nutrition.city">{{nutrition.city+","}}</span>
                  {{nutrition.zipCode}}
                </p>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SocialMedia from "@/components/SocialMediaWidget.vue";
import DisponibilityCard from "@/components/coachComponents/DisponibiltyCard.vue";
import ExperienceComponent from "@/components/partnerComponents/ExperienceComponent.vue";
import DiplomaComponent from "@/components/partnerComponents/DiplomaComponent.vue";
import ScheduleCard from "@/components/partnerComponents/ScheduleCard.vue";
import { RDVPicker } from "@/components/partnerComponents";

import LoginPopup from "@/components/authentication/LoginPopup";

export default {
  props: ["id"],
  components: {
    SocialMedia,
    DisponibilityCard,
    ExperienceComponent,
    DiplomaComponent,
    ScheduleCard,
    LoginPopup,
    RDVPicker,
  },
  data() {
    return {
      isBookClicked: false,
      isLoginPopun: false,
      isLightboxVisible: false,
      lightboxImg: "",
      tab: null,
    };
  },
  beforeMount() {
    this.getNutrition(this.$route.params.id);
  },
  methods: {
    ...mapActions({
      getNutrition: "loadNutritionById",
    }),
    onBookCoach() {
      if (this.userIsAuthenticated) this.isBookClicked = true;
      else this.pushLoginForm();
    },
    pushLoginForm() {
      this.isLoginPopun = true;
    },
    photoConvert(url) {
      if (url === null || url === undefined) {
        return process.env.VUE_APP_API_URL_COACH_AVATAR;
      }
      if (url.startsWith("https://sprint-app.com")) return url;
      else return url + "?height=500";
    },
    closeDialog(type) {
      if (type == "bookCoach") this.isBookClicked = false;
      else this.isLoginPopun = false;
    },
  },
  computed: {
    ...mapGetters({
      nutrition: "getNutritionById",
      loading: "loading",
      user: "user",
    }),
    userIsAuthenticated() {
      return this.user !== null && this.user !== undefined;
    },
  },
};
</script>